module.exports = __webpack_public_path__ + "static/media/7.b973b3fa.jpg";